import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { LeagueId } from '../types';

const LEAGUE_STORAGE_KEY = 'quinielas_selected_league';

interface LeagueContextType {
  league: LeagueId | null;
  setLeague: (league: LeagueId | null) => void;
  clearLeague: () => void;
}

export const LeagueContext = createContext<LeagueContextType>({
  league: null,
  setLeague: () => {},
  clearLeague: () => {},
});

export const LeagueProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [league, setLeagueState] = useState<LeagueId | null>(() => {
    try {
      const stored = localStorage.getItem(LEAGUE_STORAGE_KEY);
      if (stored === 'liga_mx' || stored === 'mundial_fifa') return stored;
    } catch (_) {}
    return null;
  });

  useEffect(() => {
    try {
      if (league) {
        localStorage.setItem(LEAGUE_STORAGE_KEY, league);
      } else {
        localStorage.removeItem(LEAGUE_STORAGE_KEY);
      }
    } catch (_) {}
  }, [league]);

  const setLeague = useCallback((value: LeagueId | null) => {
    setLeagueState(value);
  }, []);

  const clearLeague = useCallback(() => {
    setLeagueState(null);
  }, []);

  const value = { league, setLeague, clearLeague };

  return (
    <LeagueContext.Provider value={value}>
      {children}
    </LeagueContext.Provider>
  );
};

export const useLeague = () => {
  const context = useContext(LeagueContext);
  if (context === undefined) {
    throw new Error('useLeague must be used within a LeagueProvider');
  }
  return context;
};
